/** Unicode NFC, tüm boşluk türlerini tek ASCII boşluğa indirir, kırpar. Harf büyüklüğüne dokunmaz. */
export function normalizeText(s) {
    return s.normalize('NFC').replace(/[\s ]+/g, ' ').trim();
}
//# sourceMappingURL=normalize.js.map